import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';
import { Dictionary } from '../../../../../type_definitions/vendor';
import { IStatusIconLegend } from '../../bp-profiles.service';
import { OEMFilterCode } from '../oem/bp-profiles-oem-data.service';
import { STATE_BPPROFILES_ACCESS_SETTINGS, STATE_BPPROFILES_CATALOG_OVERVIEW, STATE_BPPROFILES_CAVEATS, STATE_BPPROFILES_CONTACTS, STATE_BPPROFILES_OEM_OVERVIEW, STATE_BPPROFILES_SLA, STATE_BPPROFILES_TC } from '../../../../shared/app-states';
import { IObject } from '../../../../../type_definitions/datatypes';

export enum ProfileChecklistStatus {
  AVAILABLE = 'AVAILABLE',
  MANDATORY_NOT_AVAILABLE = 'MANDATORY_NOT_AVAILABLE',
  OPTIONAL_NOT_AVAILABLE = 'OPTIONAL_NOT_AVAILABLE',
  NOT_AVAILABLE = 'NA'
}

interface IProfileChecklistFieldDetail {
  displayText?:string;
  linkedUrl?:string;
  linkedContent?:string;
  linkedContentToggle?:boolean; // This is used for toggling linked content extra information
  internalUrl?:IProfileChecklistState; // This is used for formatting internal state (ui router state)
  externalUrl?:string; // This is used for displaying external URL (ga1 links)
}

export interface IProfileChecklist {
  status?:ProfileChecklistStatus;
  description?:IProfileChecklistFieldDetail;
  itemValue?:IProfileChecklistFieldDetail;
  extraInformation?:IProfileChecklistFieldDetail;
  symbolicName?:string;
  statusIcon?:IStatusIconLegend; // Show status icon of every checklists
}

export interface IProfileChecklistState {
  state?:string;
  params?:IObject;
}

@Injectable()
export class BPProfilesChecklistsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public get statusIconLegends():IStatusIconLegend[] {
    return [
      {
        iconClass: 'fa fa-check-circle table-ok-icon checklists-status-legend',
        label: 'GA.BUTTONS.OK'
      },
      {
        iconClass: 'fa fa-exclamation-circle table-warning-icon checklists-status-legend',
        label: 'BPPROFILES.PROFILE_CHECKLIST.STATUS_ICON.OPTIONAL'
      },
      {
        iconClass: 'fa fa-exclamation-circle table-error-icon checklists-status-legend',
        label: 'BPPROFILES.PROFILE_CHECKLIST.STATUS_ICON.MANDATORY'
      }
    ];
  }

  public get internalLinks():Dictionary<IProfileChecklistState> {
    return {
      'CHECKLIST_CM': { state: STATE_BPPROFILES_CONTACTS },
      'CHECKLIST_MARGIN': { state: STATE_BPPROFILES_TC },
      'CHECKLIST_TIER': { state: STATE_BPPROFILES_OEM_OVERVIEW, params: { filter: OEMFilterCode.INFO_MISSING } },
      'CHECKLIST_EMAIL_SUFFIX': { state: STATE_BPPROFILES_ACCESS_SETTINGS },
      'CHECKLIST_AUTOMATIC_DISTRIBUTION': { state: STATE_BPPROFILES_ACCESS_SETTINGS },
      'CHECKLIST_NAM': { state: STATE_BPPROFILES_CONTACTS },
      'CHECKLIST_SLA': { state: STATE_BPPROFILES_SLA },
      'CHECKLIST_PAYMENTTERMS': { state: STATE_BPPROFILES_TC },
      'CHECKLIST_CENTRAL': { state: STATE_BPPROFILES_TC },
      'CHECKLIST_CAVEATS': { state: STATE_BPPROFILES_CAVEATS },
      'CHECKLIST_TC': { state: STATE_BPPROFILES_TC },
      'CHECKLIST_LOCSERV': { state: STATE_BPPROFILES_CATALOG_OVERVIEW, params: { category: 'SERVICES' } },
      'CHECKLIST_ROLES': { state: STATE_BPPROFILES_CONTACTS },
      'CHECKLIST_ENGRATE': { state: STATE_BPPROFILES_CATALOG_OVERVIEW, params: { category: 'ENGINEERS' } }
    };
  }
  
  public getProfileChecklists(profileId:number):Promise<IProfileChecklist[]> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/profilechecklist`,
      undefined,
      undefined,
      'Error loading profile checklists'
    );
  }
}